<div class="p-20 fx-row fx-wrap align-items-center justify-content-center text-center">
  <div class="fx-flex-100 align-items-center justify-content-center text-center">
    <span class="title mb-10 text-center">{{ (changing ? 'ACCESS.DIALOG.CHANGE_TITLE' : 'ACCESS.DIALOG.ENTER_TITLE') | translate }}</span>
  </div>
  <span class="text mt-20">{{ 'ACCESS.DIALOG.INSTRUCTIONS' | translate: { organization: organization.name } }}</span>
  <div class="fx-flex-100 fx-column align-items-stretch justify-content-start mt-20 text-left">
    <app-select class="fx-flex-100 mb-10" id="access-dialog-role" [label]="'ACCESS.DIALOG.ROLE' | translate"
      [labelOutside]="true" [options]="roles" [multiple]="false" [clearable]="false" [emitOnInit]="false"
      [value]="role" (valueChange)="onRoleChange($event)"></app-select>

    @if (role === 'CASE_OPERATOR') {
      <div class="fx-column mb-10" id="access-dialog-cases">
        <span class="label">{{ 'ACCESS.DIALOG.CASES' | translate: { count: selectedCases.length, max: SCOPE_MAX_VALUES } }}</span>
        <app-input class="mt-5" type="text" prefix="search" [placeholder]="('ACTIONS.SEARCH' | translate) + '...'"
          [(value)]="caseQuery" (change)="onCaseQueryChange()"></app-input>
        @if (selectedCases.length > 0) {
          <div class="fx-row fx-wrap align-items-center justify-content-start mt-8">
            @for (option of selectedCases; track option._id) {
              <div class="chip main small fx-row align-items-center mr-5 mb-5 clickable" (click)="toggleCase(option)">
                {{ caseLabel(option) }}
                <mat-icon class="main ml-5" inline fontSet="material-icons-outlined">close</mat-icon>
              </div>
            }
          </div>
        }
        <div class="access-cases mt-8">
          @for (option of cases; track option._id) {
            <div class="fx-row align-items-center justify-content-start clickable actionable access-case"
              [class.disabled]="!isCaseSelected(option) && selectedCases.length >= SCOPE_MAX_VALUES"
              (click)="toggleCase(option)">
              <mat-checkbox color="primary" [checked]="isCaseSelected(option)"
                [disabled]="!isCaseSelected(option) && selectedCases.length >= SCOPE_MAX_VALUES"></mat-checkbox>
              <div class="fx-column align-items-start justify-content-start ml-5">
                <span class="text">{{ caseLabel(option) }}</span>
                <span class="small light">{{ option.trademark.name }} {{ option.trademark.identifierNumber }}</span>
              </div>
            </div>
          } @empty {
            <div class="p-8">
              <span class="text light">{{ (loadingCases ? 'ACCESS.DIALOG.CASES_LOADING' : 'PAGINATOR.GENERIC_SEARCH_NO_RESULTS') | translate }}</span>
            </div>
          }
        </div>
        <span class="small light mt-5">{{ 'ACCESS.DIALOG.CASES_HINT' | translate: { max: SCOPE_MAX_VALUES } }}</span>
      </div>
    }

    @if (role === 'COUNTRY_OPERATOR') {
      <app-territory-select class="fx-flex-100 mb-10" id="access-dialog-territories"
        [label]="'ENTITIES.TERRITORIES' | translate" [labelOutside]="true" [multiple]="true" [search]="true"
        [unrestricted]="true" [value]="territories" [emitOnInit]="false" (valueChange)="onTerritoriesChange($event)"
        [hint]="'ACCESS.DIALOG.TERRITORIES_HINT' | translate: { count: territories.length, max: SCOPE_MAX_VALUES }"
        [bottomWrapper]="true"></app-territory-select>
    }

    <app-input class="fx-flex-100" id="access-dialog-reason" type="text" [label]="'ACCESS.DIALOG.REASON' | translate"
      [placeholder]="'ACCESS.DIALOG.REASON_PLACEHOLDER' | translate" [value]="reason"
      (valueChange)="onReasonChange($event)" [error]="reasonError" [bottomWrapper]="true"></app-input>
  </div>
  <span class="small light fx-flex-100 mt-10">{{ 'ACCESS.DIALOG.JOURNALED' | translate }}</span>
  <mat-divider class="fx-flex-100 mv-20"></mat-divider>
  <div class="fx-row align-items-center justify-content-center fx-flex-100">
    <button class="button fx-flex mr-10" (click)="onCancel()">{{ 'ACTIONS.CANCEL' | translate }}</button>
    <button class="main-button fx-flex ml-10" id="access-dialog-submit" (click)="onConfirm()"
      [class.disabled]="isDisabled()" [disabled]="isDisabled()">
      {{ (changing ? 'ACCESS.CHANGE_ROLE' : 'ACCESS.ENTER') | translate }}
    </button>
  </div>
</div>
